export default __webpack_public_path__ + "static/media/icon_right_small_20_Regular_green.523ee30f.svg";